module.exports = __webpack_public_path__ + "img/si.dafbfa54.svg";